import { Star, MapPin, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/lib/siteData";

export const GMBSection = () => {
  return (
    <section data-testid="gmb-section" className="section-pad relative bg-background">
      <div className="container-site">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-5">
            <p className="kicker mb-3">Find us on Google</p>
            <h2 className="font-display uppercase text-foreground text-[clamp(2rem,5vw,3.5rem)] leading-[0.95] text-balance">
              Cape Town’s trusted <span className="text-[hsl(var(--primary))]">video production</span> partner.
            </h2>
            <p className="mt-5 text-sm sm:text-base text-muted-foreground leading-relaxed">
              We’re listed on Google Business as a video production company in Cape Town. Drop by, check reviews, or send us a message directly through Google.
            </p>
            <div className="mt-6 flex items-center gap-3 text-sm">
              <MapPin className="h-4 w-4 text-[hsl(var(--primary))]" />
              <span className="text-muted-foreground">{SITE.location}</span>
            </div>
            <div className="mt-2 flex items-center gap-3 text-sm">
              <Star className="h-4 w-4 text-[hsl(var(--primary))] fill-current" />
              <span className="text-muted-foreground">Verified Google Business Profile</span>
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button data-testid="gmb-profile-button" asChild className="h-11 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:brightness-110 px-5">
                <a href={SITE.gmb.searchUrl} target="_blank" rel="noreferrer noopener">View on Google</a>
              </Button>
              <Button data-testid="gmb-review-button" asChild variant="ghost" className="h-11 rounded-full border border-border bg-card/60 hover:bg-card px-5">
                <a href={SITE.gmb.profileUrl} target="_blank" rel="noreferrer noopener"><MessageSquare className="mr-2 h-4 w-4" />Leave a review</a>
              </Button>
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="relative rounded-2xl overflow-hidden border border-border aspect-[4/3] sm:aspect-[16/10] bg-card">
              <iframe
                data-testid="gmb-map-iframe"
                src={SITE.gmb.mapEmbedUrl}
                title="Pie in the Sky Productions on Google Maps"
                className="absolute inset-0 h-full w-full grayscale contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="pointer-events-none absolute inset-0 bg-[hsl(var(--background)/0.15)] mix-blend-multiply" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
